import React from "react";
import { MainLayout } from "../components/layout/mainLayout";
import AppReleases from "../components/appReleases/appReleases";

const AppReleasesPage = () => {
  return (
    <MainLayout>
      <AppReleases />
    </MainLayout>
  );
};

export default AppReleasesPage;
